import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from 'redux/store'
import { ThemeProvider } from '@material-ui/core'

import * as serviceWorker from './serviceWorker'
import './index.css'
import Router from './Router'
import theme from 'utils/theme'
import { AuthLoader } from 'components'

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AuthLoader>
        <Router />
      </AuthLoader>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
